/**
 * Quick-add for the clearance lineup page.
 * Adds the variant via the theme's cart route, re-renders the cart drawer + bubble,
 * and opens the cart drawer as a confirmation (same UX as the product pages).
 * Never does a full-page redirect to /cart.
 */
(function () {
  var SECTIONS = [
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function innerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function renderCart(state) {
    if (!state || !state.sections) return;
    SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      if (!host || !state.sections[s.section]) return;
      var target = host.querySelector(s.selector) || host;
      try { target.innerHTML = innerHTML(state.sections[s.section], s.selector); } catch (e) {}
    });
    // Re-bind drawer behaviour if the theme class is available (guarded — it needs the toggle button).
    try {
      if (typeof CartDrawer !== 'undefined' && document.getElementById('cart-drawer-toggle')) new CartDrawer();
    } catch (e) {}
  }

  function openDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return; // no drawer on the page: cart count still updates, but never full-redirect
    document.body.classList.add('open-cc', 'open-cart');
    drawer.classList.add('active');
    try { drawer.focus(); } catch (e) {}
    var rec = drawer.querySelector('.product-recommendations--full');
    if (rec) rec.classList.add('active');
    if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.clearance-quickadd[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('loading')) return;
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url : '/cart/add.js';
    var body = new URLSearchParams();
    body.append('id', btn.getAttribute('data-variant-id'));
    body.append('quantity', '1');
    body.append('sections', SECTIONS.map(function (s) { return s.section; }).join(','));
    body.append('sections_url', window.location.pathname);

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: body.toString()
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status) return; // add error (e.g. sold out) — leave page untouched
        renderCart(state);
        openDrawer();
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', { product: state.items ? state.items[0] : state });
        }
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  });
})();
